module.exports = __webpack_public_path__ + "media/images/icons/plan-icon-b0f956041c10d107adf747fa42bdf96b.svg";